<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="疯狂收藏" @back="goBack" /></span>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="slv" label="开始等级">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.slv" placeholder="倍率" />
            </template>
          </el-table-column>
          <el-table-column prop="elv" label="结束等级">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.elv" placeholder="结束等级" />
            </template>
          </el-table-column>
          <el-table-column prop="num" label="倍率">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.num" placeholder="倍率" />
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-permisaction="['config:rewardCardGroup:del']" style="margin-top: 10px" type="danger" @click="del(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:rewardCardGroup:add']" style="margin-top: 10px" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:rewardCardGroup:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getActivtyStageRewardCfg, updateActivtyStageRewardCfg } from '@/api/config/activity-cfg'
export default {
  name: 'CrazyCardGroup',
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      aid: 0,
      type: 0,
      ucType: 0,
      isOnline: 0,
      formData: [
        {
          'stage': 0,
          'slv': 0,
          'elv': 0,
          'num': ''
        }
      ]
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    onSubmit() {
      const formData = this.formData
      const newformData = {}
      let j = 1
      for (const i in formData) {
        formData[i].stage = j
        newformData[j] = formData[i]
        j++
      }
      const postData = { type: this.type, aid: this.aid, reward: newformData }
      const data = JSON.stringify(postData)
      updateActivtyStageRewardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.formData = []
          const data = res.data.reward
          if (data) {
            for (const i in data) {
              this.formData.push(data[i])
            }
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        stage: 0,
        slv: 0,
        elv: 0,
        num: 0
      })
    },
    del(i) {
      this.formData = this.formData.filter((item, k) => {
        return k !== i
      })
    }
  }
}
</script>

<style scoped>
</style>
